import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=3c41856e"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports